define(['jquery',
        'core/chargebee-modals'],
    function($, chargebee_modals) {

        return {
            init: function() {
                // -------
                // BILLING
                // -------
                $('#button-portal').click(function(event) {
                    event.preventDefault();
                    chargebee_modals.openPortalModal();
                });
            }
        };
    }
);
